import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { MaterialModule } from 'src/app/material.module';
import { StatusModule } from 'src/app/platform/nomenclatoare/status-cerere/status.module';
import { DocumentAccessTypesModule } from 'src/app/platform/nomenclatoare/document-access-types/document-access-types.module';
import { PrioritiesModule } from 'src/app/platform/nomenclatoare/priorities/priorities.module';
import { DocumentTypesModule } from 'src/app/platform/nomenclatoare/document-types/document-types.module';
import { SeriesDocumentsModule } from 'src/app/platform/nomenclatoare/series-documents/series-documents.module';
import { SourcesDocumentsModule } from 'src/app/platform/nomenclatoare/sources-documents/sources-documents.module';
import { PersonsEntityTypesModule } from 'src/app/platform/nomenclatoare/persons-entity-types/persons-entity-types.module';
import { DocumentFinalizationTypesModule } from 'src/app/platform/nomenclatoare/document-finalization-types/document-finalization-types.module';
import { NonWorkingDaysModule } from 'src/app/platform/nomenclatoare/non-working-days/non-working-days.module';
import { DocumentTypesFilesModule } from 'src/app/platform/nomenclatoare/document-types-files/document-types-files.module';
import { RedirectionAddressesModule } from 'src/app/platform/nomenclatoare/redirection-addresses/redirection-addresses.module';
import { DirectieSeriiModule } from 'src/app/platform/nomenclatoare/directie-serii/directie-serii.module';
import { EmailsBlacklistModule } from 'src/app/platform/nomenclatoare/emails-blacklist/emails-blacklist.module';
import { OperatoriModule } from 'src/app/platform/nomenclatoare/operatori/operatori.module';
import { GeneralModule } from 'src/app/platform/nomenclatoare/general/general.module';
import { TemplateCategoriesModule } from 'src/app/platform/nomenclatoare/template-categories/template-categories.module';
import { DocumentTemplateModule } from 'src/app/platform/nomenclatoare/document-template/document-template.module';
import { StatusPostaModule } from 'src/app/platform/nomenclatoare/status-posta/status-posta.module';
import { OficiuPostalModule } from 'src/app/platform/nomenclatoare/oficiu-postal/oficiu-postal.module';
import { DocumentHeaderFooterModule } from 'src/app/platform/nomenclatoare/document-header-footer/document-header-footer.module';

@NgModule({
    declarations: [SettingsComponent],
    imports: [
        CommonModule,
        MaterialModule,
        StatusModule,
        DocumentAccessTypesModule,
        PrioritiesModule,
        DocumentTypesModule,
        SeriesDocumentsModule,
        SourcesDocumentsModule,
        PersonsEntityTypesModule,
        DocumentFinalizationTypesModule,
        NonWorkingDaysModule,
        DocumentTypesFilesModule,
        RedirectionAddressesModule,
        StatusModule,
        DirectieSeriiModule,
        EmailsBlacklistModule,
        OperatoriModule,
        GeneralModule,
        TemplateCategoriesModule,
        DocumentTemplateModule,
        StatusPostaModule,
        OficiuPostalModule,
        DocumentHeaderFooterModule,
    ],
    exports: [SettingsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsModule { }
